export default {
  UNLOADED: 0,
  LOADING_RELAYS: 1,
  RELAYS_LOADED: 2,
  CONNECTING: 3,
  CONNECTED: 4,
  ERRORED: 5
};
